<template>
  <div class="chosedialog">
    <el-dialog :close-on-click-modal="false" @close='send' v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao"
               append-to-body width="75%">
      <div class="h-rowIn">
        <div class="h-rowBox">
          <div class="h-rowCon yxline">
            <div class="h-piece">
              <div class="l-screenBox">
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="Cancellation">取消</el-button>
                  <el-button class="h-btn h-formBtn h-bggreen" @click="dingdadd">确定</el-button>
                </div>
              </div>
            </div>
            <el-table
                ref="multipleTableLd"
                :data="dataLd"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChangeLd">
              <el-table-column
                  label="序号"
                  type="index"
                  width="50px">
              </el-table-column>
              <el-table-column
                  prop="areaName"
                  label="区域"
                  width="100">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.areaName"
                             placeholder="请选择"
                             filterable>
                    <el-option
                        @click.native="qiehuanjinezhekou(scope.row)"
                        v-for="item in areaList"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="province"  label="省" width="100px" ></el-table-column>
              <el-table-column prop="city"  label="市" width="80px" ></el-table-column>
              <el-table-column
                  prop="salesManName"
                  label="销售人员"
                  width="110">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.salesManName"
                             placeholder="请选择"
                             filterable>
                    <el-option
                        v-for="item in salesmanList"
                        :key="item.userName"
                        :label="item.userName"
                        :value="item.userName">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="channelName" label="渠道名称" width="100px" ></el-table-column>
              <el-table-column prop="clueFromName" label="线索来源" width="100px" ></el-table-column>
              <el-table-column prop="userUnitName" label="用户单位" width="180px"></el-table-column>
              <el-table-column prop="leader" label="负责人" width="100px" ></el-table-column>
              <el-table-column prop="incomingCall" label="来电电话" width="120px" ></el-table-column>
              <el-table-column prop="telephone" label="联系方式" width="120px" ></el-table-column>
              <el-table-column prop="userRequire" :show-overflow-tooltip="true"  label="用户需求" width="120px" ></el-table-column>
              <el-table-column prop="memo" :show-overflow-tooltip="true" label="备注" width="120px" ></el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
              <paginationmin :page="qLd" @query="getLoudList"/>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ss from '../../api/SystemService'
import updownfile from '../../utils/updownfile';
import dict from "../../views/basic/dict";

export default {
  name: "alluser",
  data() {
    return {
      dataLd: [],
      multipleSelectionLd: [],
      qLd: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        agentName: '',// 经销商
        agentCode: '',// 经销商编码
        funnelCode: '',//漏斗编码
        customerName: '',// 用户单位
        customerChannel: '',// 渠道
        ddlx: '', //订单类型
      },// 选择漏斗查询条件
      ttdata: null,
      lists: [],
      dailishangFlag: true,
      userRole: '',
      imgflag3: false,
      salesmanList: [],  // 销售人员list
      areaList: [],
    }
  },
  methods: {
    send: function () { // 向夫组件传值
      this.$refs.multipleTableLd.clearSelection();
      this.$emit('getChildValue',false)
    },

    getLoudList() {
      ss.BscClueManage.selecttoLeadPage(this.qLd).then(rd => {
        this.dataLd = rd.msg.records;
        this.qLd.total = rd.msg.total || 0;
      })
    },
    restLd() {
      this.qLd.funnelCode = '';
      this.qLd.customerName = '';
      this.qLd.customerChannel = '';
    },
    dingdadd() {
      if (this.dataLd.length < 1){
        this.$message.error("没有可确定的数据!");
        return false;
      }
      var dataLd =  this.dataLd;

      dataLd.forEach(a=>{

      });

      ss.BscClueManage.ImportListDetermination(dataLd).then(rd => {
        this.$emit('getChildValue',false);
      })
    },
    Cancellation(){
      if (this.dataLd.length < 1){
        this.$message.error("没有可取消的数据!");
        return false;
      }
      this.$confirm('确定取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.BscClueManage.ImportListCancellation().then(rd => {
          this.$emit('getChildValue',false);
        })
      }).catch(() => {
      });
    },

    qiehuanjinezhekou(row){
      debugger
      //查该区域下的销售人员
      var areaList = this.areaList;
      var area =  areaList.find(a => a.name == row.areaName)
      row.areaCode = area.code
      ss.UserService.selectUserNamesBydaquAndarea(area.name).then(names => {
        this.salesmanList = names.obj;
      })
    },

    handleSelectionChangeLd(val) {
        this.multipleSelectionLd = val;
    },
    selectable(row, index) {
        return true;
    },

    handleFilter() {
      this.querypage();
    },
    querypage(p) {
    },
    handleSelectionChange(lists) {
      if (this.oneflag) {
        this.$emit('choseObj', lists[0])
      } else {
        this.lists = lists;
      }
    },
    choseSelected() {
      this.$emit('choseObj', this.lists)
    },
    downExcel() {
      updownfile.down("/api/select/wuliao/downloadExcel", this.q, "post");
    },
  },
  created() {
    this.getLoudList();
    this.areaList = this.$store.getters.dicts["show_area"];
  },
  computed: {

  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
    country: {
      type: String,
    }
  }
}
</script>

<style>
.xuanzewuliao .el-dialog__header {
  padding-top: 20px;
  padding-left: 20px;
}

.xuanzewuliao .el-dialog__body {
  padding: 20px;
}

.xuanzewuliao .el-table tbody td .cell {
  padding: 0.1rem 0.1rem !important;
}

.xuanzewuliao .h-formbLine .el-form-item__label {
  width: 39%;
}

.xuanzewuliao .h-formbLine .el-form-item__content {
  width: 61%;
}

.xuanzewuliao .yxline .h-formbLine .el-form-item__content {
  width: 61%;
}

.xuanzewuliao .yxline {
  padding-top: 0;
}

.xuanzewuliao .h-pagination {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.xuanzewuliao .h-rowCon {
  padding-bottom: 0rem;
}

.w-tongyi {
  padding: 0.1rem 0.25rem;
}

/*.el-dialog {*/
/*  width: 1600px;*/
/*}*/
</style>
